import React, { useState, useEffect } from 'react';
import {
    Button,
    TextField,
    Select,
    MenuItem,
    IconButton,
    Box,
    CircularProgress,
    Typography,
    InputLabel,
    FormControl,
    Paper,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { getActionList } from '../../../services/api/nbaApi';
import { useDispatch, useSelector } from 'react-redux';
import { asString } from '../../../services/typeUtils';
import { getPrizeList } from '../../../store/actions/prizeActions';

const ActionCreator = ({ actionsData, setData, isPublished }) => {
    const [actions, setActions] = useState(actionsData);
    //const [availableActions, setAvailableActions] = useState(actionsList.data);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { market } = useSelector((store) => store.auth.user);

    // Fetch action list only once
    // useEffect(() => {
    //     //getActionList(market)
    //        // .then((response) => {
    //            // setAvailableActions(response.data);
    //             setLoading(false);
    //         })
    //         .catch((err) => {
    //             setError('Failed to fetch actions');
    //             setLoading(false);
    //         });
    // }, [market]);

    // Sync actions with parent state
    useEffect(() => {
        setData(actions); // Update parent component's state whenever actions change
    }, [actions, setData]);

    const handleActionChange = (updatedAction, index) => {
        const updatedActions =
            (Array.isArray(actions) &&
                actions?.map((action, i) =>
                    i === index ? updatedAction : action
                )) ||
            [];
        setActions(updatedActions);
    };

    const handleAddAction = () => {
        setActions([
            ...actions,
            {
                domain: '',
                attributeName: '',
                operation: '',
                attributeValue: '',
            },
        ]);
    };

    const handleDeleteAction = (index) => {
        const updatedActions = actions.filter((_, i) => i !== index);
        setActions(updatedActions);
    };

    return (
        <>
            <Box
                p={4}
                mx="auto"
                sx={{
                    padding: 2,
                    marginBottom: 3,
                    boxShadow: 3,
                    backgroundColor: '#e5f0f6',
                    borderRadius: '4px',
                }}
            >
                {Array.isArray(actions) &&
                    actions.map((action, index) => (
                        <Action
                            key={index}
                            index={index}
                            // actionData={actionsData}
                            actionData={action}
                            onActionChange={(a, i) => handleActionChange(a, i)}
                            onDeleteAction={handleDeleteAction}
                            //  availableActions={availableActions}
                            loading={loading}
                            error={error}
                            disabled={isPublished}
                            showDeleteCta={actions.length > 1 && !isPublished}
                        />
                    ))}
            </Box>
            {/* disable multiple actions */}
            <Box mt={2}>
                <Button
                    color="primary"
                    onClick={handleAddAction}
                    style={{
                        backgroundColor: '#e5f0f6',
                        color: '#000',
                        border: '1px solid #8fb8f9',
                    }}
                    disabled={isPublished}
                >
                    <AddIcon /> Add Action
                </Button>
            </Box>
        </>
    );
};

const Action = ({
    index,
    actionData,
    onActionChange,
    onDeleteAction,
    availableActions,
    loading,
    error,
    disabled,
    showDeleteCta = false,
}) => {
    const { prizeItems } = useSelector((state) => state.prize);
    const dispatch = useDispatch();
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (actionData.attributeName === 'raffleEntry' && value > 10) return;

        onActionChange({ ...actionData, [name]: value }, index);
    };
    useEffect(() => {
        dispatch(getPrizeList());
    }, []);

    return (
        <Paper elevation={2} sx={{ margin: (theme) => theme.spacing(2) }}>
            <Box display="flex" alignItems="center" gap={2} my={2} p={2}>
                {loading ? (
                    <Box display="flex" alignItems="center" width="100%">
                        <CircularProgress size={24} />
                        <Typography variant="body2" ml={2}>
                            Loading actions...
                        </Typography>
                    </Box>
                ) : error ? (
                    <Typography variant="body2" color="error">
                        {error}
                    </Typography>
                ) : (
                    <>
                        <FormControl fullWidth disabled={disabled}>
                            <InputLabel
                                sx={{ color: '#000', backgroundColor: '#fff' }}
                                shrink
                            >
                                Entity
                            </InputLabel>
                            <Select
                                name="domain"
                                value={actionData.domain}
                                onChange={handleInputChange}
                                displayEmpty
                                fullWidth
                            >
                                {/* // {availableActions.map((action) => {return ( */}
                                <MenuItem value="Consumer">Consumer</MenuItem>

                                {/* //     );
                                // })} */}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth disabled={disabled}>
                            <InputLabel
                                sx={{ color: '#000', backgroundColor: '#fff' }}
                                shrink
                            >
                                Event Attribute is
                            </InputLabel>

                            <Select
                                name="attributeName"
                                value={actionData.attributeName}
                                onChange={handleInputChange}
                                displayEmpty
                                fullWidth
                            >
                                {/* // {availableActions.map((action) => {return ( */}
                                <MenuItem value="points">Points</MenuItem>
                                <MenuItem value="raffleEntry">
                                    Raffle Entry
                                </MenuItem>
                                <MenuItem value="voucher">Voucher</MenuItem>
                                <MenuItem value="cash">Cash</MenuItem>
                                {/* //     );
                                // })} */}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth disabled={disabled}>
                            <InputLabel
                                sx={{ color: '#000', backgroundColor: '#fff' }}
                                shrink
                            >
                                Operation
                            </InputLabel>
                            <Select
                                name="operation"
                                value={actionData.operation}
                                onChange={handleInputChange}
                                displayEmpty
                                fullWidth
                            >
                                {/* // {availableActions.map((action) => {return ( */}
                                <MenuItem value="==">==</MenuItem>
                                {/* //     );
                                // })} */}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel
                                sx={{ color: '#000', backgroundColor: '#fff' }}
                                shrink
                                htmlFor="attributeValue"
                            >
                                Attribute Value is
                            </InputLabel>
                            {(actionData.attributeName === 'points' ||
                                actionData.attributeName === 'raffleEntry') && (
                                <TextField
                                    id="attributeValue"
                                    name="attributeValue"
                                    type="number"
                                    value={actionData.attributeValue}
                                    onChange={(e) => {
                                        handleInputChange(e);
                                    }}
                                    fullWidth
                                    disabled={disabled}
                                    inputProps={{
                                        max:
                                            actionData.attributeName ===
                                            'raffleEntry'
                                                ? 10
                                                : undefined,
                                    }}
                                />
                            )}
                            {actionData.attributeName === 'voucher' && (
                                <Select
                                    id="attributeValue"
                                    name="attributeValue"
                                    value={actionData.attributeValue}
                                    onChange={(e) => {
                                        handleInputChange(e);
                                    }}
                                    fullWidth
                                    disabled={disabled}
                                    sx={{ color: 'black' }}
                                    renderValue={(selected) => {
                                        const pr = prizeItems.find(
                                            (prize) =>
                                                prize.loyaltyPrizeItemId ===
                                                parseInt(selected, 10)
                                        );
                                        return pr
                                            ? `${pr.merchantName} - ${pr.denominationValue} - ${pr.denominationQuantity}`
                                            : '';
                                    }}
                                >
                                    {prizeItems
                                        .filter(
                                            (prize) =>
                                                prize.status === 'ACTIVE' &&
                                                prize.prizeType === 'VOUCHER'
                                        )
                                        .map((pr) => (
                                            <MenuItem
                                                value={pr.loyaltyPrizeItemId}
                                                key={pr.loyaltyPrizeItemId}
                                            >{`${pr.merchantName} - ${pr.denominationValue} - ${pr.denominationQuantity}`}</MenuItem>
                                        ))}
                                </Select>
                            )}
                            {actionData.attributeName === 'cash' && (
                                <Select
                                    id="attributeValue"
                                    name="attributeValue"
                                    value={actionData.attributeValue}
                                    onChange={(e) => {
                                        handleInputChange(e);
                                    }}
                                    fullWidth
                                    disabled={disabled}
                                    sx={{ color: 'black' }}
                                    renderValue={(selected) => {
                                        const pr = prizeItems.find(
                                            (prize) =>
                                                prize.loyaltyPrizeItemId ===
                                                parseInt(selected, 10)
                                        );
                                        return pr
                                            ? `${pr.prizeType} - ${pr.denominationValue}`
                                            : '';
                                    }}
                                >
                                    {prizeItems
                                        .filter(
                                            (prize) =>
                                                prize.status === 'ACTIVE' &&
                                                prize.prizeType === 'CASH'
                                        )
                                        .map((pr) => (
                                            <MenuItem
                                                value={pr.loyaltyPrizeItemId}
                                                key={pr.loyaltyPrizeItemId}
                                            >{`${pr.prizeType} - ${pr.denominationValue}`}</MenuItem>
                                        ))}
                                </Select>
                            )}
                        </FormControl>

                        {showDeleteCta && (
                            <IconButton
                                aria-label="delete"
                                onClick={() => onDeleteAction(index)}
                                sx={{ color: '#c8102e' }}
                                disabled={disabled}
                            >
                                <DeleteIcon />
                            </IconButton>
                        )}
                    </>
                )}
            </Box>
        </Paper>
    );
};

export default ActionCreator;
